export const getFileFormat = (fileName) => {
    if (!fileName) return null;

    const lastIndex = fileName.lastIndexOf('.');
    return fileName.slice(lastIndex + 1, fileName.length);
};
